//@flow
import React, { useEffect } from "react";
import UserInterface from "./ui-main";
import { Actions } from "../../services/actions";
import Store from "../../services/store";
import Hls from "hls.js";
import { Container } from "flux/utils";
import fluxfix from "../../services/fluxfix";
import { AudioSource } from "./source";
import { startSession, endSession } from "./sessionReporting";

type Props = {};
type State = {
  Store: Object,
};
class AudioPlayerContainer extends React.Component<Props, State> {
  constructor(props: Object) {
    super(props);
    this.state = { Store: {} };
  }
  static getStores() {
    return [Store];
  }

  static calculateState(prevState) {
    return { Store: Store.getState() };
  }

  render() {
    return <AudioPlayer currentSrc={this.state.Store.get("currentSrc")} desiredPlayState={this.state.Store.get("desiredPlayState")} playState={this.state.Store.get("playState")} />;
  }
}

const audioRef: Object = React.createRef<Object>();
window.audioRef = audioRef;

const AudioPlayer = (props: Object): Object => {
  const { currentSrc, desiredPlayState, playState } = props;

  // console.log("PLAYNEW:", currentSrc);
  useEffect(() => {
    // if(currentSrc?.src !== audioRef?.current?.src){

    setSource(currentSrc, audioRef, true);
    if (audioRef.current) {
      audioRef.current.onwaiting = () => {
        Actions.setPlayState("BUFFERING");
      };
      audioRef.current.onloadstart = () => {
        console.log("load start");
        Actions.setPlayState("BUFFERING");
      };
      audioRef.current.onplaying = () => {
        Actions.setPlayState("PLAYING");
        // Actions.setIsBuffering(false);
        // Actions.setAutoplayPrevented(false);
        startSession(currentSrc);
        // this.isStale = false;
        // clearTimeout(this.staleTimer);
      };

      audioRef.current.oncanplaythrough = () => {
        // Actions.setPlayState("PLAYING");
        // this._waitForGoingStale();
      };

      audioRef.current.onpause = () => {
        Actions.setPlayState("PAUSED");
        // this._waitForGoingStale();
        endSession();
      };
      audioRef.current.onerror = () => {
        Actions.setPlayState("PAUSED");
        endSession();
      };

      audioRef.current.ondurationchange = () => {
        if (!audioRef.current) return;
        const duration = audioRef.current.duration;
        duration && Actions.setDuration(duration);
        duration && localStorage.setItem(currentSrc.src + "_duration", duration);
      };

      audioRef.current.ontimeupdate = () => {
        if (!audioRef.current) return;

        const currentTime = audioRef.current.currentTime;
        currentTime && localStorage.setItem(currentSrc.src + "_currentTime", currentTime);
        currentTime && Actions.setCurrentTime(currentTime);
      };

      audioRef.current.onseeked = () => {
        // this._log("seeked");
        if (audioRef?.current) {
          Actions.setCurrentTime(audioRef?.current?.currentTime);
        }
      };
    }
    // }
  }, [currentSrc]);

  useEffect(() => {
    if (desiredPlayState) {
      console.log("Play");
      const res = audioRef?.current?.play();
      if (res !== undefined) {
        res
          .then((_) => {
            // Autoplay started!
          })
          .catch((error) => {
            console.error(error);
            // window.alert(error);

            setTimeout(() => {
              Actions.setPlayState("PAUSED");
              Actions.setDesiredPlayState(false);
            }, 500);
            console.log("autoplay prevented!! (hls.js)");
            Actions.setAutoplayPrevented(true);
            Actions.setHidePanel(false);
          });
      }
    } else {
      console.log("Pause");
      audioRef?.current?.pause();
    }
  }, [desiredPlayState, currentSrc]);

  return (
    <React.Fragment>
      <UserInterface currentSrc={currentSrc} playState={playState} />
      <audio preload="none" autoPlay={false} controls={false} ref={audioRef} type="audio/mpeg" src={currentSrc?.src} />
    </React.Fragment>
  );
};

export default (Container.create(fluxfix.convert(AudioPlayerContainer)): Object);

const setSource = (audioSource: AudioSource, ref: Object, playWhenLoaded: boolean): void => {
  const a = ref.current;
  console.log("set source", audioSource?.src);
  if (!audioSource?.src) {
    a.pause();
    return;
  }
  // if (this.audio && audioSource.src !== this.audio.src) {
  // NEW AUDIO SOURCE
  // this._log("setSource:", audioSource);
  // startSession(audioSource);

  // if (!this.audio) {
  // this._log("Audio is null");
  // return;
  // }

  // this.currentAudioSource = audioSource;

  // this was added to avoid false starts when skipping
  // but stalls the enitre player on iOS safari
  // if (this.audio) this.audio.muted = true;
  ////////////////

  const savedTime = Number(localStorage.getItem(audioSource.src + "_currentTime")) || 0;

  // console.log(savedTime);
  const configLIVE = {
    // abrBandWidthFactor: 0.5,
    // abrBandWidthUpFactor: 0.5,
    liveDurationInfinity: true,
    maxMaxBufferLength: 20, //5
    // debug: true,
    // liveDurationInfinity: true,
    ////////
    // how much to keep for rewind
    backBufferLength: 30,
    ////////
    // number of segments from edge of live
    liveSyncDurationCount: 3, //(3 default)//this is in NUMBER OF SEGMENTS
    liveMaxLatencyDurationCount: 6, //maximum delay allowed from edge of live IN SEGMENTS
    ////////////////
    // liveMaxLatencyDuration
    // (default: Infinity)
    // maximum delay allowed from edge of live, expressed in
    // multiple of EXT-X-TARGETDURATION. if set to 10, the player will seek
    // back to liveSyncDurationCount whenever the next fragment to be loaded
    // is older than N-10, N being the last fragment of the live playlist.
    // If set, this value must be stricly superior to liveSyncDurationCount a
    // value too close from liveSyncDurationCount is likely to cause playback stalls.
    // liveMaxLatencyDuration: 7, //6
    ////////////
    ///////////
    // liveSyncDuration
    // edge of live delay, in seconds
    // edge of live delay, expressed in multiple of EXT-X-TARGETDURATION.
    // if set to 3, playback will start from fragment N-3, N being the last
    // fragment of the live playlist. decreasing this value is likely to
    // cause playback stalls.
    // liveSyncDuration: 3, //////////// this is in SECONDS
  };

  const configPODCAST = {};

  // let audio = this.audio;
  // if (!audio) return;

  if (Hls.isSupported()) {
    // console.warn("Forcing HLS.JS")
    console.log("using hls.js");
    window.hls && window.hls.destroy();

    console.log("audiosource is livestream?", audioSource.isLiveStream);
    // If the browser supports MSE, use hls.js to play the video
    const config = audioSource.isLiveStream ? configLIVE : configPODCAST;
    // console.log(config);
    window.hls = new Hls(config);
    window.hls.loadSource(parseWeightedURL(audioSource.src));
    window.hls.attachMedia(a);
    // window.hls.startLevel = 2;

    window.hls.on(Hls.Events.MANIFEST_PARSED, function () {
      if (playWhenLoaded) {
        // Actions.setDesiredPlayState(true)
      }
      // !this.isLiveStream && this.seek(savedTime);
      //   const promise = a.play();

      //   if (promise !== undefined) {
      //     promise
      //       .then((_) => {
      //         // Autoplay started!
      //       })
      //       .catch((error) => {
      //         setTimeout(
      //           () => {
      //             Actions.setIsPlaying(false);
      //             Actions.setIsBuffering(false);
      //           },

      //           500
      //         );

      //         console.log("autoplay prevented!! (hls.js)");
      //         Actions.setAutoplayPrevented(true);
      //       });
      //   }
      // }
    });

    window.hls.on(Hls.Events.ERROR, function (event, data) {
      // var errorType = data.type;
      // var errorDetails = data.details;
      // var errorFatal = data.fatal;
      console.error(event, data);
      switch (data.details) {
        case Hls.ErrorDetails.FRAG_LOAD_ERROR:
          // playerControl._log(errorType, errorDetails);
          break;
        default:
          // playerControl._log(errorType, errorDetails);
          break;
      }
      if (data.fatal) {
        switch (data.type) {
          case Hls.ErrorTypes.NETWORK_ERROR:
            // try to recover network error
            console.log("fatal network error encountered, try to recover");
            window.hls.startLoad();
            break;
          case Hls.ErrorTypes.MEDIA_ERROR:
            console.log("fatal media error encountered, try to recover");
            window.hls.recoverMediaError();
            break;
          default:
            // cannot recover
            window.hls.destroy();
            break;
        }
      }
    });
  } else if (a.canPlayType("application/vnd.apple.mpegurl")) {
    console.log("using native HLS");

    // If HLS is natively supported, let the browser do the work!
    a.src = audioSource.src;
    a.load();

    a.addEventListener("loadedmetadata", function () {
      if (playWhenLoaded) {
        // Actions.setDesiredPlayState(true)
        //   const promise = a.play();
        //   if (promise !== undefined) {
        //     promise
        //       .then((_) => {
        //         // Autoplay started!
        //       })
        //       .catch((error) => {
        //         console.log("autoplay prevented (native)");
        //         Actions.setAutoplayPrevented(true);
        //       });
        //   }
      }
    });
  } else {
    alert("Playback is not supported in this browser. See http://idrad.io/help");
  }

  // !audioSource.isLiveStream && savedTime > 0 && this.seek(savedTime);
  ///////////

  if (!audioSource.isLiveStream && savedTime > 0) {
    // safari won't seek back to saved position properly
    // so we add a delay
    if (/apple/i.test(navigator.vendor)) {
      //safari
      a.muted = true;
      setTimeout(() => {
        a.currentTime = savedTime;
        a.muted = false;
      }, 1000);
    } else {
      //not safari
      if (!audioSource.isLiveStream && savedTime > 0) {
        a.currentTime = savedTime;
      }
    }
  }
  // see above re safari
  // setTimeout(
  //   () => {
  //     if (this.audio) this.audio.muted = false;
  //   },

  //   500
  // );
  // } else {
  //   this._log("src is already loaded", audioSource);
  //   if (playWhenLoaded) this.play();
  // }

  // Actions.setCurrentSrc(audioSource);

  // playerControl.isFirstLoad = false;
};

const parseWeightedURL = (u: string): string => {
  const options = u.split(";");

  const items: Array<string> = [];
  options.forEach((o) => {
    console.log(o);
    const urlc = o.split(",")[0];
    const weight = Number(o.split(",")[1]) || 1;
    for (let index = 0; index < weight; index++) {
      items.push(urlc);
    }
  });
  const url = items[(items.length * Math.random()) | 0];
  // console.log("Weighted URL choice: ", url);
  return url;
};
